import entities from './entities';

let routeTypes = {
  CREATE: 'create',
  LIST: 'list',
  DETAILS: 'details',
  SIMPLE: ''
};

export function getRouteName(type, entity) {
  if(!type) {
    return entity;
  }
  return `${entity}_${type}`;
}

export {
  entities,
  routeTypes
}
